const numericForms = function (value, form1, form2, form5) {
    return `${value} ${numericWord(value, form1, form2, form5)}`;
};

const numericWord = function (value, form1, form2, form5) {
    const stringValue = value.toString();

    if (stringValue.endsWith("0") ||
        stringValue.endsWith("11") ||
        stringValue.endsWith("12") ||
        stringValue.endsWith("13") ||
        stringValue.endsWith("14") ||
        stringValue.endsWith("15") ||
        stringValue.endsWith("16") ||
        stringValue.endsWith("17") ||
        stringValue.endsWith("18") ||
        stringValue.endsWith("19") ||
        stringValue.endsWith("5") ||
        stringValue.endsWith("6") ||
        stringValue.endsWith("7") ||
        stringValue.endsWith("8") ||
        stringValue.endsWith("9"))
    {
        return form5;
    } else if (stringValue.endsWith("1")) {
        return form1;
    } else {
        return form2;
    }
};

export {
    numericForms,
    numericWord
}


// WEBPACK FOOTER //
// ./src/utils/formatters.js